import React from "react";
import { CRMSpacing } from "../../../../models/CRMSpacing";
import { CRMColors } from "../../../../models/CRMColors";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import { SpacingRow } from "../../../BuildingBlocks/SpacingRow";
import { Border } from "../../../BuildingBlocks/Border";
import { Padding } from "../../../BuildingBlocks/Padding";
import { MaxWidth } from "../../../BuildingBlocks/MaxWidth";
import { CRMButtonQuaternary } from "../../../CRMButtonQuaternary/CRMButtonQuaternary";
import { CRMRedemptionStatementAttachment } from "../../../Complex/CRMRedemptionStatementAttachment/CRMRedemptionStatementAttachment";
import { TCaseChargeLegalFile2 } from "../../../../../../domain/codecs/CaseChargeLegalFile";

export const CRMRedemptionStatementAttachmentInserted = (props: {
    index: number;
    redemptionStatement: TCaseChargeLegalFile2;
    onRemove: () => void;
}): JSX.Element => (
    <Border type="bottom" definition={`1px solid ${CRMColors.NEUTRAL_8}`}>
        <Padding type="bottom" spacing={CRMSpacing.LARGE}>
            <SpacingColumn spacing={CRMSpacing.MEDIUM}>
                <SpacingColumn spacing={CRMSpacing.TINY}>
                    <MaxWidth width="450px">
                        <CRMRedemptionStatementAttachment
                            tagPrefix={`${props.index}. `}
                            redemptionStatement={props.redemptionStatement}
                        />
                    </MaxWidth>
                </SpacingColumn>

                <SpacingRow>
                    <CRMButtonQuaternary
                        label="Remove"
                        icon="delete"
                        onClick={props.onRemove}
                    />
                </SpacingRow>
            </SpacingColumn>
        </Padding>
    </Border>
);
